import api from "./axios";
import { NotificationListResponse, UnreadCountResponse, FcmTokenResponse } from "../types/notification";

export const getNotificationHistory = async (
    userId: number,
    limit?: number
): Promise<NotificationListResponse> => {
    const response = await api.get(`/notification/history/${userId}`, {
        params: limit ? { limit } : undefined
    });
    return response.data;
};

export const getMyNotifications = async (
    params?: { limit?: number; page?: number; unread_only?: boolean }
): Promise<NotificationListResponse> => {
    const response = await api.get("/notification/my", { params });
    return response.data;
};

export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
    const response = await api.get("/notification/unread-count");
    return response.data;
};

export const markAsRead = async (notificationId: number): Promise<any> => {
    const response = await api.patch(`/notification/history/${notificationId}/read`);
    return response.data;
};

export const markAllAsRead = async (): Promise<any> => {
    const response = await api.patch("/notification/mark-all-read");
    return response.data;
};

export const sendFcmToken = async (token: string): Promise<FcmTokenResponse> => {
    const response = await api.post("/users/fcm-token", { fcm_token: token });
    return response.data;
};

export const removeFcmToken = async (): Promise<FcmTokenResponse> => {
    const response = await api.delete("/users/fcm-token");
    return response.data;
};
